import React from 'react';
import './Contact.css';
import messengerIcon from '../assets/images1/facebook messenger_messenger logo_icon.png';  // Adjust path as needed

const Contact = () => {
  return (
    <section id="contact" className="contact-section">
      <h2 className="contact-heading">Contact Us</h2>

      {/* Messenger Links Section */}
      <div className="contact-messenger-links">
        <div className="messenger-link">
          <a href="https://m.me/684365005017799" target="_blank" rel="noopener noreferrer">
            Click here to message Millicent Kyokushin Karate on Facebook
          </a>
          <img src={messengerIcon} alt="Messenger Icon" />
        </div>
        <div className="messenger-link">
          <a href="https://m.me/144334605439641" target="_blank" rel="noopener noreferrer">
            Click here to message Mount Gambier Kyokushin Karate on Facebook
          </a>
          <img src={messengerIcon} alt="Messenger Icon" />
        </div>
        <div className="messenger-link">
          <a href="https://m.me/617860278227264" target="_blank" rel="noopener noreferrer">
            Click here to message Allendale Kyokushin Karate on Facebook
          </a>
          <img src={messengerIcon} alt="Messenger Icon" />
        </div>
      </div>

      <hr className="messenger-divider" />  {/* Horizontal line divider */}

      {/* Contact Form 
      <div className="contact-form-container">
        <form className="contact-form">
          <div className="contact-form-group">
            <label htmlFor="name">Name:</label>
            <input type="text" id="name" name="name" required />
          </div>
          <div className="contact-form-group">
            <label htmlFor="email">Email:</label>
            <input type="email" id="email" name="email" required />
          </div>
          <div className="contact-form-group">
            <label htmlFor="message">Message:</label>
            <textarea id="message" name="message" rows="4" required></textarea>
          </div>
          <div className="contact-form-group">
            <label htmlFor="club">Select Club:</label>
            <select id="club" name="club" required>
              <option value="Millicent">Millicent</option>
              <option value="Mount Gambier">Mount Gambier</option>
              <option value="Allendale">Allendale</option>
            </select>
          </div>
          
          <div className="contact-submit-container">
            <button type="submit" className="submit-btn">Submit</button>
          </div>
        </form>
      </div> */}
    </section>
  );
};

export default Contact;
